import Vue from "vue";
import Router from "vue-router";
import index from "../view/index";
import contact from "../view/contact";
import about from "../view/about";
import news from "../view/news";
import detail from "../view/detail";
import myCase from "../view/case";
Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "/",
      component: index
    },
    {
      path: "/index",
      component: index
    },
    {
      path: "/contact",
      component: contact
    },
    {
      path: "/about",
      component: about
    },
    {
      path: "/news",
      component: news
    },
    {
      path: "/detail/:function/:id",
      component: detail
    },
    {
      path: "/case",
      component: myCase
    }
  ]
});
router.afterEach(() => {
  window.scrollTo(0, 0);
});
export default router;
